import { render, staticRenderFns } from "./QProductLibraryAgentSubmenu.vue?vue&type=template&id=0aa85c85&"
import script from "./QProductLibraryAgentSubmenu.vue?vue&type=script&lang=js&"
export * from "./QProductLibraryAgentSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports